/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'right_arrow': {
    width: 6,
    height: 11,
    viewBox: '0 0 6 11',
    data: '<path pid="0" d="M.871.432L0 1.28l4.266 4.153L0 9.585l.871.847L6 5.44l-.006-.007L6 5.426z" _fill="#234357" fill-rule="nonzero"/>'
  }
})
